import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  SUA_TIEN_LAI,
  SUA_TIEN_GOC,
  SUA_TIEN_GOP,
  NHAP_PHI_PHAT,
} from "actions/DongLai/actionTypes";
import {
  suaTienLaiSuccess,
  suaTienLaiFailure,
  suaTienGocSuccess,
  suaTienGocFailure,
  suaTienGopSuccess,
  suaTienGopFailure,
  nhapPhiPhatSuccess,
  nhapPhiPhatFailure,
} from "actions/DongLai";
import DongLaiApi from "service/dongLaiApi";
import { pushNotification } from "utils/notifications";
import { getLanDongLaiChoVay } from "actions/QuanLyChoVay";
import { getInLanDongLai } from "actions/InLanDongLai";

function* suaTienLai(action) {
  try {
    const response = yield call(DongLaiApi.suaTienLai, action.dataPost);
    if (response.ok) {
      yield put(suaTienLaiSuccess(response.data));
      yield put(getLanDongLaiChoVay(action.dataSearch));
      yield put(
        getInLanDongLai({
          chovayId: action.dataSearch.choVayId,
          isHienLaiGoc: 1,
        })
      );
      // thêm phần isHienLaiGoc: 1 cho phần in 14/06/2024
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(suaTienLaiFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(suaTienLaiFailure());
  }
}
function* suaTienGoc(action) {
  try {
    const response = yield call(DongLaiApi.suaTienGoc, action.dataPost);
    if (response.ok) {
      yield put(suaTienGocSuccess(response.data));
      yield put(getLanDongLaiChoVay(action.dataSearch));
      yield put(
        getInLanDongLai({
          chovayId: action.dataSearch.choVayId,
          isHienLaiGoc: 1,
        })
      );
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(suaTienGocFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(suaTienGocFailure());
  }
}

function* suaTienGop(action) {
  try {
    const response = yield call(DongLaiApi.suaTienGop, action.dataPost);
    if (response.ok) {
      yield put(suaTienGopSuccess(response.data));
      yield put(getLanDongLaiChoVay(action.dataSearch));
      yield put(
        getInLanDongLai({
          chovayId: action.dataSearch.choVayId,
          isHienLaiGoc: 1,
        })
      );
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(suaTienGopFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(suaTienGopFailure());
  }
}

function* nhapPhiPhat(action) {
  try {
    const response = yield call(DongLaiApi.nhapPhiPhat, action.dataPost);
    if (response.ok) {
      yield put(nhapPhiPhatSuccess(response.data));
      yield put(getLanDongLaiChoVay(action.dataSearch));
      yield put(
        getInLanDongLai({
          chovayId: action.dataSearch.choVayId,
          isHienLaiGoc: 1,
        })
      );
      if (response.data.Error === 1) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(nhapPhiPhatFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(nhapPhiPhatFailure());
  }
}
function* watchGetRequest() {
  yield takeLatest(SUA_TIEN_LAI, suaTienLai);
  yield takeLatest(SUA_TIEN_GOC, suaTienGoc);
  yield takeLatest(SUA_TIEN_GOP, suaTienGop);
  yield takeLatest(NHAP_PHI_PHAT, nhapPhiPhat);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
